import { useCallback } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";
import { SearchPage } from "../views/search/SearchPage";
import { searchPageSearchSchema, type SearchPageSearch } from "../views/search/params";
import { rootRoute } from "./root";

export const searchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/search",
  validateSearch: searchPageSearchSchema,
  component: function SearchRoute() {
    usePageTitle("Search");
    const search = searchRoute.useSearch();
    const navigate = useNavigate({ from: "/search" });
    const onSearch = useCallback(
      (next: SearchPageSearch) => {
        void navigate({ search: next });
      },
      [navigate],
    );
    return <AppFrame view="Search">{() => <SearchPage search={search} onSearch={onSearch} />}</AppFrame>;
  },
});
